import { validateBIC as bicValidator, validateIBAN as ibanValidator, extractIBAN } from 'ibantools';
import { Texts } from '@luckycart/xpn-types/build/src/entities/reward-config.entity';

export const validateRequired = (value: string, missingMessage: string): string | undefined => {
  if (!value.trim()) {
    return missingMessage;
  }

  return undefined;
};

export const validatePhoneNumber = (phoneNumber: string, missingMessage: string, invalidMessage: string): string | undefined => {
  const phoneNumberRegex = /^0\d{9}$/u;

  if (!phoneNumber.trim()) {
    return missingMessage;
  } else if (!phoneNumberRegex.test(phoneNumber)) {
    return invalidMessage;
  }

  return undefined;
};

export const validateZipCode = (zipCode: string, missingMessage: string, invalidMessage: string): string | undefined => {
  const zipCodeRegex = /^[0-9]{5}$/u;

  if (!zipCode.trim()) {
    return missingMessage;
  } else if (!zipCodeRegex.test(zipCode)) {
    return invalidMessage;
  }

  return undefined;
};

export const validatePaypalField = (
  paypal: string,
  missingMessage: string,
  invalidMessage: string
): string | undefined => {
  const paypalRegex =
    /^(?![#$%&'*+\-/=?^_`{|}~])[\w\d!#$%&'*+\-/=?^_`{|}~]+(?:\.[\w\d!#$%&'*+\-/=?^_`{|}~]+)*@[a-zA-Z0-9]+(?:[.-][a-zA-Z0-9]+)*(?:\.[a-zA-Z]{2,3})+$/u;

  if (!paypal.trim()) {
    return missingMessage;
  } else if (!paypalRegex.test(paypal)) {
    return invalidMessage;
  }

  return undefined;
};

export const validateIban = (
  value: string,
  texts: Texts,
  siteCountryCode: string,
  missingMessage: string,
  invalidMessage: string
): string | undefined => {
  if (!value.trim()) {
    return missingMessage;
  }

  const { countryCode } = extractIBAN(value);

  if (!ibanValidator(value).valid || countryCode === undefined) {
    return invalidMessage;
  }

  if (countryCode !== siteCountryCode) {
    return texts.ibanCountryError;
  }

  return undefined;
};

export const validateBic = (
  value: string,
  texts: Texts,
  siteCountryCode: string,
  missingMessage: string,
  invalidMessage: string
): string | undefined => {
  if (!value.trim()) {
    return missingMessage;
  } else if (!bicValidator(value).valid) {
    return invalidMessage;
  }
  const countryCode = extractCountryFromBIC(value);
  if (countryCode !== siteCountryCode) {
    return texts.bicCountryError;
  }
  return undefined;
};

const extractCountryFromBIC = (bic: string): string | null => {
  if (!bic || bic.length < 6) {
    return null;
  }
  return bic.slice(4, 6).toUpperCase();
};
